import createClient from "openapi-fetch";
import type { paths } from "./schema.d.ts";
import { authMiddleware } from "./middleware";
import { bracketQuerySerializer } from "./querySerializer";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_API_URL,
  querySerializer: bracketQuerySerializer,
});
client.use(authMiddleware);

export default client;
